/**
 * Header 组件类型枚举
 * 用于区分在 Header 中显示的不同类型组件
 */
export enum HeaderType {
  /** 价格显示组件 (Bitcoin/Token 价格) */
  PRICE_DISPLAY = "price_display",

  /** 市场信息显示组件 */
  MARKET_INFO = "market_info",

  /** 股票信息显示组件 */
  STOCK_INFO = "stock_info",

  /** Aura 信息显示组件 */
  AURA_INFO = "aura_info",

  /** 自定义组件 */
  CUSTOM = "custom",
}

/**
 * Header 数据接口
 * 扩展后的统一数据结构，支持多种组件类型
 */
export interface HeaderData {
  /** 组件类型标识 */
  key: HeaderType;

  /** 当前价格 */
  current_price?: number;

  /** 24小时价格变化百分比 */
  priceChangePercentage24h?: number;

  /** 价格绝对变化金额 (用于STOCK_INFO类型) */
  price_change?: number;

  /** tokenData */
  tokenData?: {
    icon?: string;
    name?: string;
    symbol?: string;
    id?: string;
    type?: string;
  };

  /** 是否是poll token */
  isPollToken?: boolean;

  /** 标题 */
  title?: string;

  /** 副标题 */
  subtitle?: string;

  /** Aura 数据 (用于AURA_INFO类型) */
  auraData?: {
    boostAvailable?: number;
    credits?: number;
    creditYield?: number;
  };

  /** 扩展数据字段，支持任意自定义数据 */
  additionalData?: Record<string, any>;
}
